import request from "@/utils/request";
import qs from "qs";
// 获取产品资料

export function xcBankAccSetup(params) {
  return request({
    url: "api/xcBankAccSetup" + "?" + qs.stringify(params, { indices: false }),
    method: "get",
  });
}



// WEBPACK FOOTER //
// ./src/api/reservationRecord.js